import { render, staticRenderFns } from "./UpdateMoreClassPlan.vue?vue&type=template&id=5ae3ccfc&scoped=true&"
import script from "./UpdateMoreClassPlan.vue?vue&type=script&lang=js&"
export * from "./UpdateMoreClassPlan.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMoreClassPlan.vue?vue&type=style&index=0&id=5ae3ccfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae3ccfc",
  null
  
)

export default component.exports